import { SITE } from "@/data/site"

function MusicScent() {
  return (
    <section className="relative w-full overflow-hidden bg-[#0c0c0c]">
      <div className="grid w-full items-stretch md:grid-cols-2">
        <div className="relative mx-4 min-h-[70vh] overflow-hidden md:mx-0 md:min-h-screen">
          <img
            src={SITE.music}
            alt="Wild Thing"
            className="absolute inset-0 h-full w-full object-cover object-center grayscale-[15%]"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-black/20" />
        </div>
        <div className="flex flex-col items-center justify-center px-8 py-24 text-center md:px-16 md:py-24 lg:px-20">
          <p className="font-sans-ui text-[11px] tracking-[0.48em] text-[#c4a574]">03</p>
          <h2 className="font-display mt-5 text-4xl text-[#f7f1e6] md:text-6xl">音樂 × 氣味</h2>
          <p className="font-serif-tc mx-auto mt-14 whitespace-nowrap text-[17px] leading-snug text-stone-100 sm:text-xl md:text-2xl">
            音樂，是野東西的語言
            <br />
            氣味，是我們延伸故事的方式
          </p>
          <p className="font-sans-ui mx-auto mt-10 max-w-xs text-[13px] leading-7 text-stone-400 md:mt-14 md:max-w-sm md:text-sm md:leading-8">
            〈Free Man〉把自由寫進旋律，
            <br />
            香氣再把故事帶到身體上。
            <br />
            從耳朵聽見的旋律，
            <br />
            到記憶裡留下的味道，
            <br />
            讓野東西不只被聽見，也被記住。
          </p>
        </div>
      </div>
    </section>
  )
}

export default MusicScent
